import type { PostApiArbitrageAccept422 } from '@/api/placementApi.schemas';

const IDENTITY_VALIDATION_FAILED = 'IDENTITY_VALIDATION_FAILED';

// Le mutator fetch ne rejette pas les réponses non-2xx : le 422 d'accept arrive donc comme une
// réponse « réussie » et doit être reconnu à son corps.
const isIdentityValidationFailed = (response: unknown): response is PostApiArbitrageAccept422 =>
  typeof response === 'object' &&
  response !== null &&
  (response as PostApiArbitrageAccept422).error === IDENTITY_VALIDATION_FAILED;

// Forme lue par UniversignDocumentsForm (prop `universignError`) pour afficher le bon bandeau dès le montage.
// `pieceMRZ` n'y est pas lu : une MRZ illisible est rendue comme une pièce illisible, comme à la soumission.
const toUniversignErrorState = (error: PostApiArbitrageAccept422) => ({
  success: false,
  pieceLu: error.pieceMRZ === true ? false : (error.pieceLu ?? undefined),
  infosNonCorrespondante: error.infosNonCorrespondante ?? undefined,
  pieceExpire: error.pieceExpire ?? undefined,
  coordonneesUtilise: error.coordonneesUtilise ?? undefined,
  emailUtilise: error.emailUtilise ?? null,
  telephoneUtilise: error.telephoneUtilise ?? null,
});

export { isIdentityValidationFailed, toUniversignErrorState };
